import { action } from 'typesafe-actions';
import * as constants from './constants';
import * as models from '../../models';

// dropdowns
export const requestPolicyTypeDD = () =>
    action(constants.REQUEST_POLICY_TYPE_DD); 

export const receivePolicyTypeDD = (response: models.DropdownListResponse) =>
    action(constants.RECEIVE_POLICY_TYPE_DD, { response }); 